import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/magic-icon.svg";
import officeIMG from "../../images/about/office.jpg";


const AboutUsPage = (props) => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" className="rounded-circle"/> About TigrisPay
                    </span>
                    <h2 className="title">
                      Fast, Secure & Reliable Money <br />
                      Transfers with TigrisPay
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="about-video pt-75">
          <div className="container">
            <div className="career_video">
              
                <img src={officeIMG} alt="" />
                {/* <source src={Video} type="video/mp4" />
                Your browser does not support the video tag. */}
              
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pt-80 pb-110">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                We are TigrisPay
              </h2>
              <p className="sd-content fs-5">
                At TigrisPay, we are dedicated to simplifying global transactions for businesses. Our platform provides seamless and secure solutions for businesses in the UK to send money to Nigeria and beyond. Whether you're making payments, transfers, or cross-border transactions, TigrisPay ensures that your business can move money with ease, speed, and confidence.
              </p>
              <br />
              <p className="sd-content fs-5">
             We specialize in seamless international money transfers, with a strong focus on the UK–Nigeria corridor. Our platform is designed with advanced security protocols, real-time transaction tracking, and competitive exchange rates to ensure your funds arrive safely and on time. With TigrisPay, you're not just sending money — you're sending it with confidence and control.
              </p>
                <br />
              <p className="sd-content fs-5">
              We believe in transparency, speed, and customer satisfaction. Our intuitive dashboard, responsive customer support, and flexible payment options empower users to manage their cross-border payments effortlessly — whether it's payroll, supplier invoices, tuition fees, or family remittances.
              </p>
               <br />
               <p className="sd-content fs-5">
              Join the growing community of businesses and individuals who trust TigrisPay to handle their international transactions. Experience the future of remittance — fast, secure, and tailored to your needs.
              </p>
            </div>
          </div>
        </div>

        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutUsPage;
